import { isSameRow } from './is-same-row'
import { forEachRowEl } from './row-dom-registry'
import { getRowId } from './row-id'
import type { DataGrid } from '../types'

export const CURRENT_ROW_CLASS = 'is-current'

export function resolveRowDomId(
  $grid: DataGrid,
  row: Record<string, unknown> | null | undefined
): string | null {
  if (!row) {
    return null
  }
  if (row.id != null && row.id !== '') {
    return String(row.id)
  }
  if (row._gridRowId != null) {
    return String(row._gridRowId)
  }
  const { tableData } = $grid.reactData
  const index = tableData.findIndex((item) => isSameRow(item, row))
  return getRowId(row, index >= 0 ? index : undefined)
}

function toggleRowClass(
  $grid: DataGrid,
  rowId: string,
  active: boolean
) {
  forEachRowEl($grid, rowId, (el) => {
    el.classList.toggle(CURRENT_ROW_CLASS, active)
  })
}

export function syncCurrentRowDom(
  $grid: DataGrid,
  prevRow: Record<string, unknown> | null,
  nextRow: Record<string, unknown> | null
) {
  if (prevRow) {
    const prevId = resolveRowDomId($grid, prevRow)
    if (prevId) {
      toggleRowClass($grid, prevId, false)
    }
  }
  if (nextRow) {
    const nextId = resolveRowDomId($grid, nextRow)
    if (nextId) {
      toggleRowClass($grid, nextId, true)
    }
  }
}

export function applyCurrentRowClass($grid: DataGrid) {
  const root = $grid.bodyRef?.value
  if (root) {
    root.querySelectorAll(`.z-grid__row.${CURRENT_ROW_CLASS}`).forEach((el) => {
      el.classList.remove(CURRENT_ROW_CLASS)
    })
  }
  syncCurrentRowDom($grid, null, $grid.reactData.currentRow)
}
